"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.dashboards", ["nucont.shared"]);
require("./dashboards.eager-controllers.entry");
require("./dashboards.routes");
